<template>
  
  <div class="modal fade" id="popUpPraticheIntestatario" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #ffad69;">
                    <h4 style="color:#fff" class="modal-title">Pratiche per l'intestatario {{ personaFisicaSelezionata.COGNOME }} {{ personaFisicaSelezionata.NOME }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="max-height:600px">
                    <ul class="list-group">
                        <li class="list-group-item" v-for="pratica in arrayPraticheIntestatario" v-bind:key="pratica" style="cursor:pointer" v-on:click="openPratica(pratica.ID_PRATICA)">
                            <div class="float-left ml-1">
                                <i class="fa-3x" v-bind:class="pratica.ICONA"  style="color:#ffad69"></i>
                            </div>
                            <div class="float-left ml-3">
                                <strong>[{{ pratica.ID_PRATICA }}] {{ pratica.TITOLO }}</strong>
                                <br/>
                                <small>DATA CREAZIONE: {{filters.formatDate(pratica.DATA_CREAZIONE)}}</small>                            
                            </div>
                        </li>
                    </ul>        
                </div>
                <div class="modal-footer">
                </div>
            </div>  
        </div>
    </div>

    <SchedaPratica :ref="'schedaPratica'"  :arrayStati="arrayStati"></SchedaPratica>
</template>


<script>

import SchedaPratica from '../components/SchedaPratica.vue'


export default {
    name:'PraticheIntestatario',
    props:['arrayStati'],
    components:{
        SchedaPratica
    },
    data:function(){
        return{
            filters:global.filters,
            arrayPraticheIntestatario : new Array(),
            tipo:0,
            personaFisicaSelezionata:{},
            personaGiuridicaSelezionata:{}
        }
    }  ,
    methods:{
        praticheIntestatario : function(persona,tipo){
            this.tipo = tipo;
            if (tipo == 1){
                this.personaFisicaSelezionata = utils.clone(persona)
                global.utils.get('/emmet/pratiche/intestatario',{ID:persona.ID_PERSONA_FISICA,TIPO:1},(response)=>{
                    this.arrayPraticheIntestatario = response.data;
                    utils.openModal('popUpPraticheIntestatario');
                }); 
            }
            else{
                this.personaFisicaSelezionata = utils.clone(persona)
                global.utils.get('/emmet/pratiche/intestatario',{ID:persona.ID_PERSONA_GIURIDICA,TIPO:2},(response)=>{
                    this.arrayPraticheIntestatario = response.data;
                    utils.openModal('popUpPraticheIntestatario');
                }); 
            }           
        },
        openPratica : function(idPratica){
            this.$refs.schedaPratica.openPratica(idPratica);
        }
    }  
}
</script>

